import validation from '@ecg-marktplaats/aurora-js-validation';

import { TCountryCodes } from 'types/TCountryCodes';

const getPhoneNumberErrorKey = (phoneNumber: string, countryCode: TCountryCodes): string => {
  // phone number in forms this function is used is optional
  if (!phoneNumber) {
    return '';
  }

  const phoneValidation = validation.phone(phoneNumber, countryCode);

  if (phoneValidation.isPaidNumber) {
    return 'error.paidPhoneNumber';
  }
  if (!phoneValidation.isValid) {
    return 'error.invalidPhoneNumber';
  }

  return '';
};

export default getPhoneNumberErrorKey;
